import { render, staticRenderFns } from "./DrillItem.vue?vue&type=template&id=7b954310&scoped=true&"
import script from "./DrillItem.vue?vue&type=script&lang=js&"
export * from "./DrillItem.vue?vue&type=script&lang=js&"
import style0 from "./DrillItem.vue?vue&type=style&index=0&id=7b954310&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b954310",
  null
  
)

export default component.exports